import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_STUDENTSTATUS,
  GET_STUDENTSTATUSES,
  ADD_STUDENTSTATUS,
  UPDATE_STUDENTSTATUS,
  DELETE_STUDENTSTATUS
} from '@/queries/modules/common-data/student-status';

export async function getStudentStatuses(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTSTATUSES,
        fetchPolicy: 'network-only'
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setStudentStatuses', data.getStudentStatuses);
      context.commit('setSuccess', null);
      return data.getStudentStatuses
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getStudentStatus(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTSTATUS,
        variables: payload
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setStudentStatus', data.getStudentStatus);
      context.commit('setSuccess', null);
      return data.getStudentStatus
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addStudentStatus(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_STUDENTSTATUS,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const studentStatuses = [...context.state.studentStatuses];
      studentStatuses.push(data.addStudentStatus);
      context.commit('setStudentStatuses', studentStatuses);
      context.commit('setSuccess', newItemSuccess(data.addStudentStatus.nameLocal));

      return data.addStudentStatus
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateStudentStatus(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_STUDENTSTATUS,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.studentStatuses.findIndex(item => item.id === data.updateStudentStatus.id);
      const studentStatuses = [
        ...context.state.studentStatuses.slice(0, index),
        data.updateStudentStatus,
        ...context.state.studentStatuses.slice(index + 1)
      ];
      context.commit('setStudentStatuses', studentStatuses);
      context.commit('setSuccess', updateItemSuccess(data.updateStudentStatus.nameLocal));

      return data.updateStudentStatus
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteStudentStatus(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_STUDENTSTATUS,
        variables: payload,
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.studentStatuses.findIndex(item => item.id === data.deleteStudentStatus.id);
      const studentStatuses = [
        ...context.state.studentStatuses.slice(0, index),
        ...context.state.studentStatuses.slice(index + 1)
      ];
      context.commit('setStudentStatuses', studentStatuses);
      context.commit('setSuccess', deleteItemSuccess(data.deleteStudentStatus.nameLocal));

      return data.deleteStudentStatus
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

